

import React, { useState } from "react";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import CustomText from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "white",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

const ChangeStatusModal = ({ open, onClose, onSave, currentStatus }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Status options with translations
  const statusOptions = [
    { label: t("changeStatusModal.approved"), value: "APPROVE" },
    { label: t("changeStatusModal.rejected"), value: "REJECT" },
    { label: t("changeStatusModal.requestInfo"), value: "REQUEST_INFO" },
  ];

  const handleSave = async () => {
    if (!status) {
      toast.error("Request status is required.");
      return;
    }

    // ✅ Don’t allow if already final (Approved/Rejected)
    if (["APPROVED", "REJECTED"].includes(currentStatus)) {
      toast.error(
        `Status is already ${
          currentStatus === "APPROVED" ? "approved" : "rejected"
        }`
      );
      return;
    }

    if (!comments.trim()) {
      toast.error("Comments are required before changing status.");
      return;
    }

    setLoading(true);
    try {
      // ✅ Calls parent onSave with new action & comment
      await onSave({ action: status, comment: comments });

      // reset fields
      setStatus("");
      setComments("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <CustomText
          sx={{
            fontSize: 24,
            fontWeight: 600,
            color: "#2C384C",
            fontFamily: "Poppins, sans-serif",
            mb: 0.5,
          }}
        >
          {t("changeStatusModal.title")}
        </CustomText>

        <CustomText
          sx={{
            fontSize: 16,
            color: "#626F86",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            mb: 3,
            display: "block",
          }}
        >
          {t("changeStatusModal.subtitle")}
        </CustomText>

        {/* Status Dropdown */}
        <CustomText
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: "#44546F",
            fontFamily: "Poppins, sans-serif",
            mb: 0.5,
            textAlign: "left",
          }}
        >
          {t("changeStatusModal.requestStatus")}{" "}
          <span style={{ color: "red" }}>*</span>
        </CustomText>

        <TextField
          select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          fullWidth
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              fontSize: "15px",
              fontFamily: "Poppins, sans-serif",
              height: "42px",
              "& fieldset": { border: "2px solid #091E4224" },
              "&:hover fieldset": { border: "2px solid #006EC2" },
              "&.Mui-focused fieldset": { border: "2px solid #006EC2" },
            },
          }}
        >
          <MenuItem value="" sx={{ fontSize: "14px", fontFamily: "Poppins, sans-serif" }}>
            {t("changeStatusModal.select")}
          </MenuItem>
          {statusOptions.map((opt) => (
            <MenuItem
              key={opt.value}
              value={opt.value}
              sx={{ fontSize: "14px", fontFamily: "Poppins, sans-serif" }}
            >
              {opt.label}
            </MenuItem>
          ))}
        </TextField>

        {/* Comments */}
        <CustomText
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: "#44546F",
            fontFamily: "Poppins, sans-serif",
            mt: 2,
            mb: 0.5,
            textAlign: "left",
          }}
        >
          {t("changeStatusModal.comments")}
        </CustomText>
        <TextField
          multiline
          rows={3}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          fullWidth
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              fontSize: "15px",
              fontFamily: "Poppins, sans-serif",
              "& fieldset": { border: "2px solid #091E4224" },
              "&:hover fieldset": { border: "2px solid #006EC2" },
              "&.Mui-focused fieldset": { border: "2px solid #006EC2" },
            },
          }}
        />

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
          <CustomButton
            label={t("changeStatusModal.cancel")}
            size="small"
            onClick={onClose}
            sx={{
              backgroundColor: "transparent",
              color: "#2C384C",
              border: "none",
              "&:hover": { backgroundColor: "#F4F4F4" },
            }}
          />

          <CustomButton
            size="small"
            onClick={handleSave}
            disabled={loading}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress size={16} sx={{ color: "white" }} />
                )}
                {t("changeStatusModal.save")}
              </Box>
            }
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ChangeStatusModal;




// import React, { useState } from "react";
// import {
//   Box,
//   Modal,
//   TextField,
//   MenuItem,
//   CircularProgress
// } from "@mui/material";
// import CustomText from "../../../components/CustomText";
// import CustomButton from "../../../components/CustomButton";
// import { useTranslation } from "react-i18next";
// import {toast,Toaster} from "react-hot-toast"
// const modalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 420,
//   bgcolor: "white",
//   borderRadius: "12px",
//   boxShadow: 24,
//   p: 4,
// };

// const statusOptions = [
//   { label: "Approved", value: "APPROVE" },
//   { label: "Rejected", value: "REJECT" },
//     { label: "Request Info", value: "REQUEST_INFO" },
// ];

// const ChangeStatusModal = ({ open, onClose, onSave,currentStatus  }) => {
//   const [status, setStatus] = useState("");
//   const [comments, setComments] = useState("");
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);


//   const handleSave = async () => {
//   if (!status) {
//     // Show error if status is not selected
//     toast.error("Request status is required.");
//     return; // Exit the function to prevent further actions
//   }
//     if (["APPROVED", "REJECTED"].includes(currentStatus)) {
//     toast.error(
//       `Status is already ${currentStatus === "APPROVED" ? "approved" : "rejected"}`
//     );
//     return;
//   }
//    if (!comments.trim()) {
//     toast.error("Comments are required before changing status.");
//     return;
//   }
//     setLoading(true);
//     try {
//       await onSave({ action: status, comment: comments });
//       setStatus("");
//       setComments("");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal open={open} onClose={onClose}>

//       <Box sx={modalStyle}>
//         <CustomText
//           sx={{
//             fontSize: 24,
//             fontWeight: 600,
//             color: "#2C384C",
//             fontFamily: "Poppins, sans-serif",
//             mb: 0.5,
//           }}
//         >
//           {t("changeStatusModal.title")}
//         </CustomText>

//         <CustomText
//           sx={{
//             fontSize: 16,
//             color: "#626F86",
//             fontFamily: "Poppins, sans-serif",
//             fontWeight: 500,
//             mb: 3,
//             display: "block",
//           }}
//         >
//           {t("changeStatusModal.subtitle")}
//         </CustomText>

//         {/* Status dropdown */}
//         <CustomText
//           sx={{
//             fontSize: 14,
//             fontWeight: 500,
//             color: "#44546F",
//             fontFamily: "Poppins, sans-serif",
//             mb: 0.5,
//             display: "block",
//             textAlign:"left"
//           }}
//         >
//           {t("changeStatusModal.requestStatus")} <span style={{ color: "red" }}>*</span>
//         </CustomText>
//         <TextField
//           select
//           value={status}
//           onChange={(e) => setStatus(e.target.value)}
//           fullWidth
//           size="small"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "8px",
//               fontSize:"15px",
//                       fontFamily: 'Poppins, sans-serif',

//               height:"42px",
//               "& fieldset": { border: "2px solid #091E4224" },
//               "&:hover fieldset": { border: "2px solid #006EC2" },
//               "&.Mui-focused fieldset": { border: "2px solid #006EC2" },
//             },
//           }}
//         >
//           <MenuItem value="" sx={{fontSize:"14px",        fontFamily: 'Poppins, sans-serif',
// }}>{t("changeStatusModal.select")}</MenuItem>
//           {statusOptions.map((opt) => (
//             <MenuItem key={opt.value} value={opt.value} sx={{fontSize:"14px",        fontFamily: 'Poppins, sans-serif',
// }}>
//               {opt.label}
//             </MenuItem>
//           ))}
//         </TextField>

//         {/* Comments */}
//         <CustomText
//           sx={{
//             fontSize: 14,
//             fontWeight: 500,
//             color: "#44546F",
//             fontFamily: "Poppins, sans-serif",
//             mt: 2,
//             mb: 0.5,
//             display: "block",
//                         textAlign:"left"

//           }}
//         >
//           {t("changeStatusModal.comments")}
//         </CustomText>
//         <TextField
//           multiline
//           rows={3}
//           value={comments}
//           onChange={(e) => setComments(e.target.value)}
//           fullWidth
//           size="small"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "8px",
//               fontSize:"15px",
//                       fontFamily: 'Poppins, sans-serif',

//               "& fieldset": { border: "2px solid #091E4224" },
//               "&:hover fieldset": { border: "2px solid #006EC2" },
//               "&.Mui-focused fieldset": { border: "2px solid #006EC2" },
//             },
//           }}
//         />

//         {/* Buttons */}
//         <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
//           <CustomButton
//             label={t("changeStatusModal.cancel")}
//             size="small"
//             onClick={onClose}
//             sx={{
//               backgroundColor: "transparent",
//               color: "#2C384C",
//               border: "none",
//               "&:hover": { backgroundColor: "#F4F4F4" },
//             }}
//           />
//                <CustomButton
//             size="small"
//             onClick={handleSave}
//             disabled={loading}
//             label={
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 {loading && (
//                   <CircularProgress size={16} sx={{ color: "white" }} />
//                 )}
//                 {t("changeStatusModal.save")}
//               </Box>
//             }
//           />
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// export default ChangeStatusModal;
